module.exports = __webpack_public_path__ + "img/taborety.cdbccec5.jpg";